import React, { useEffect } from 'react';
import { Routes, useLocation, useNavigate } from 'react-router-dom';
import { setNavigate } from './lib/router';
import useOktaSessionMonitor from './hooks/useOktaSessionMonitor';
import { setCurrentRouteName } from './lib/newRelicBrowser';
import { restoreSessionWarning, initCrossTabSync } from './lib/sessionGuard';
import Layout from './Layout.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

import { authRoutes } from './routes/auth.jsx';
import { surveyRoutes } from './routes/surveys.jsx';
import { projectRoutes } from './routes/projects.jsx';
import { changeImpactRoutes } from './routes/changeImpacts.jsx';
import { taskRoutes } from './routes/tasks.jsx';
import { stakeholderRoutes } from './routes/stakeholders.jsx';
import { changeStrategyRoutes } from './routes/changeStrategy.jsx';
import { portfolioRoutes } from './routes/portfolio.jsx';
import { initiativeRoutes } from './routes/initiatives.jsx';
import { fileRoutes } from './routes/files.jsx';
import { employeeRoutes } from './routes/employees.jsx';
import { reportRoutes } from './routes/reports.jsx';
import { organizationRoutes } from './routes/organization.jsx';
import { changeInsightsRoutes } from './routes/changeInsights.jsx';
import { otherRoutes } from './routes/other.jsx';

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  restoreSessionWarning();
  initCrossTabSync();

  useEffect(() => {
    setCurrentRouteName(location.pathname);
  }, [location]);

  useOktaSessionMonitor();

  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        {authRoutes()}
        {surveyRoutes()}
        {projectRoutes()}
        {changeImpactRoutes()}
        {taskRoutes()}
        {stakeholderRoutes()}
        {changeStrategyRoutes()}
        {portfolioRoutes()}
        {initiativeRoutes()}
        {fileRoutes()}
        {employeeRoutes()}
        {reportRoutes()}
        {organizationRoutes()}
        {changeInsightsRoutes()}
        {otherRoutes()}
      </Routes>
    </Layout>
  );
}

export default App;
